import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["label", "key"]

  static values = {
    keyFormat: { type: String, default: "variable" },
  }

  connect() {
    this.hasOwnKey = this.keyTarget.value.length > 0
  }

  generateKey() {
    if (!this.hasOwnKey) {
      this.keyTarget.value = this.convertToKey(this.labelTarget.value)
    }
  }

  convertToKey(label) {
    let key = label
      .toLowerCase()
      .trim()

      // Replace special characters with a-z characters
      .replace(/[æ]/gi, "ae")
      .replace(/[ø]/gi, "oe")
      .replace(/[åä]/gi, "a")
      .replace(/[ðþ]/gi, "d")
      .replace(/[ß]/gi, "ss")
      .replace(/[é]/gi, "e")
      .replace(/[í]/gi, "i")
      .replace(/[óö]/gi, "o")
      .replace(/[ú]/gi, "u")
      .replace(/[ü]/gi, "ue")
      .replace(/[ñ]/gi, "n")
      .replace(/[ç]/gi, "c")
      .replace(/[ł]/gi, "l")

      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, "")

    if (this.keyFormatValue === "app") {
      return key
        .replace(/\s+/g, "_")
        .replace(/[^a-z0-9_\-~.]/g, "")
        .replace(/_+/g, "_")
        .replace(/^_+|_+$/g, "")
    }

    return key
      .replace(/[\s-]+/g, "_")
      .replace(/[^a-z0-9_]/g, "")
      .replace(/_+/g, "_")
      .replace(/^_+|_+$/g, "")
      .replace(/^[^a-z_]/, "_$&")
  }

  onKeyInput() {
    this.hasOwnKey = this.keyTarget.value.length > 0
  }
}
